<template>
  <el-container>
    <el-main>
      <el-row class="top-level-area">
        <div v-if="item.errMsg.length > 0" style="border: dashed 1px #FF0000; padding: 5px; color: red; text-align: start;">
          <ul>
            <template v-for="warning in item.errMsg.split('\n')">
              <li v-if="warning.length > 0" :key="warning">
                {{ warning }}
              </li>
            </template>
          </ul>
        </div>
      </el-row>
      <el-row class="top-level-area">
        <div class="input-title-block">
          <required-tag></required-tag>
          商品名
        </div>
        <input-text id="input-text-item-name" v-model="item.name" placeholder="商品名" :limit-length="lenItemName">
        </input-text>
      </el-row>
      <el-row class="top-level-area">
        <el-col :span="spanLeftSide">
          <image-files v-model="item.imageFiles"></image-files>
          <tags-area :tags.sync="item.tags" :tag-groups="tagGroups"></tags-area>
          <el-row class="input-title-block">
            <required-tag></required-tag>
            商品コメント
          </el-row>
          <input-text
            id="input-text-item-comment"
            multiline
            :rows="25"
            v-model="item.comment"
            :limit-length="lenItemComment"
            class="required"
          >
          </input-text>
          <div class="input-title-block">出品メモ(非公開)</div>
          <input-text
            id="input-text-exhibit-note"
            multiline
            type="textarea" :rows="7" v-model="item.exhibitNote"
            :limit-length="lenExibitNote"
            class="optional"
          >
          </input-text>
          <shop-note v-model="item.shopNotes"></shop-note>
          <style-number v-model="item.styleNumbers"></style-number>
        </el-col>
        <el-col :span="spanRightSide">
          <category-selector
            :category1st="item.category1st"
            :category2nd="item.category2nd"
            :category3rd="item.category3rd"
            :spanTitle="spanTitleSide"
            :spanSetting="spanSettingSide"
            @change1st="changeCategory1st($event)"
            @change2nd="changeCategory2nd($event)"
            @change3rd="changeCategory3rd($event)">
          </category-selector>
          <brand-selector
            required
            :brandname.sync="item.brandname"
            :brandid.sync="item.brand"
            :category1st="item.category1st"
          >
          </brand-selector>
          <selector
            id="selector-season"
            label="シーズン"
            v-model="item.season"
          >
            <el-option
              v-for="item in seasonSelection"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              :id="'selector-season-option-' + item.id"
            >
            </el-option>
          </selector>
          <selector
            id="selector-theme"
            label="テーマ"
            v-model="item.theme"
          >
            <el-option
              v-for="item in themeSelection"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              :id="'selector-theme-option-' + item.id"
            >
            </el-option>
          </selector>
          <exhibit-price-label
            :value="item.exhibitPrice"
            :spanTitle="spanTitleSide"
            :spanSetting="spanSettingSide"
          >
          </exhibit-price-label>
          <selector
            id="selector-delivery-method"
            v-model="item.deliveryMethod"
            label="発送方法"
            required
          >
            <el-option
              v-for="item in deliverySelection"
              :key="item.id"
              :label="item.explains"
              :value="item.id"
              :id="'selector-delivery-method-option-' + item.id"
            >
            </el-option>
          </selector>
          <input-number
            id="input-number-item-purchase-limit"
            v-model="item.purchaseLimit"
            :label="'購入期限'"
            :suffix="'日'"
            :spanTitle="spanTitleSide"
            :spanSetting="5"
            :spanSuffix="spanSuffix"
            required
          >
          </input-number>
          <color-size-button
            v-bind:spanTitle="spanTitleSide"
            v-bind:spanSetting="spanSettingSide"
            v-on:click="csDialogVisible=true"
          >
          </color-size-button>
          <color-size-dialog
            :dialogVisible.sync="csDialogVisible"
            :sizeReferences="sizeReferences"
            :sizeDetails="sizeDetails"
            :colorSelects="item.colorSelects"
            @changeColorSelects="item.colorSelects = $event"
            :sizeVariation="item.variation"
            @changeVariation="item.variation = $event"
            :sizeSelects="item.sizeSelects"
            @changeSizeSelect="item.sizeSelects = $event"
            :colorSizeSupplimental="item.colorSizeSup"
            @changeSupplimental="item.colorSizeSup = $event"
            :lenColorSizeSup="lenColorSizeSup"
          >
          </color-size-dialog>
          <input-text-box
            id="input-text-box-item-capacity-amount"
            v-model="item.capacityAmount"
            label="買付できる合計数量"
            :spanTitle="spanTitleSide"
            :spanSetting="5"
          >
          </input-text-box>
          <area-selector
            id="selector-area-item-purchase-place"
            v-model="item.purchasePlace"
            :label="'買付地'"
            :spanTitle="spanTitleSide"
            :spanSetting="spanSettingSide"
            required
          >
          </area-selector>
          <el-row>
            <el-col :span="spanTitleSide">
              <div class="input-title">
                <span>買付先ショップ名</span>
              </div>
            </el-col>
            <el-col :span="spanSettingSide">
              <input-text
                id="input-text-item-shop-name"
                v-model="item.shopName"
                :limitLength="lenShopName"
              >
              </input-text>
            </el-col>
          </el-row>
          <area-selector
            id="selector-area-item-delivery-place"
            v-model="item.deliveryPlace"
            :label="'発送地'"
            :spanTitle="spanTitleSide"
            :spanSetting="spanSettingSide"
            required
          >
          </area-selector>
          <input-number
            id="input-number-item-stock-price"
            v-model="item.stockPrice"
            :label="'仕入れ値'"
            :suffix="''"
            :spanSetting="spanPriceSide"
          >
          </input-number>
          <selector
            id="selector-item-currency"
            v-model="item.currency"
            :label="'通貨'"
            :spanTitle="spanTitleSide"
            :spanSetting="spanPriceSide"
          >
            <el-option
              v-for="type in currencyTypes"
              :key="type.value"
              :label="type.label"
              :value="type.value"
              :id="'selector-item-currency-option-' + type.value"
            >
            </el-option>
          </selector>
          <number-view
            :value="rate[item.currency]"
            label="為替"
            :suffix="''"
            :spanSetting="spanPriceSide"
          >
          </number-view>
          <input-number
            id="input-number-item-domestic-postage"
            v-model="item.domesticPostage"
            label="国内送料"
            suffix="円"
            :spanSetting="spanPriceSide"
          >
          </input-number>
          <input-number
            id="input-number-item-foreign-postage"
            v-model="item.foreignPostage"
            label="海外送料"
            suffix="円"
            :spanSetting="spanPriceSide"
          >
          </input-number>
          <input-number
            id="input-number-item-duty-cost"
            v-model="item.dutyCost"
            label="関税"
            suffix="円"
            :spanSetting="spanPriceSide"
          >
          </input-number>
          <number-view
            :value="charge"
            label="バイマ手数料"
            suffix="％"
            :spanSetting="spanPriceSide"
          >
          </number-view>
          <input-number
            v-model="item.profitRate"
            label="利益率"
            suffix="％"
            :spanSetting="spanPriceSide"
          >
          </input-number>
          <number-view
            :value="profit"
            label="利益"
            suffix="円"
            :spanSetting="spanPriceSide"
          >
          </number-view>
          <number-view
            :value="computedPrice"
            label="出品計算価格"
            suffix="円"
            :spanSetting="spanPriceSide"
          >
          </number-view>
          <input-number
            id="input-number-item-exhibit-price"
            v-model="item.exhibitPrice"
            label="出品価格"
            suffix="円"
            :spanSetting="spanPriceSide"
            required>
          </input-number>
          <number-view
            :value="Math.floor(profit / item.exhibitPrice * 1000) / 10"
            label="実利益率"
            suffix="％"
            :spanSetting="spanPriceSide"
          >
          </number-view>
          <number-view
            :value="item.exhibitPrice * profit / item.exhibitPrice"
            label="実利益"
            suffix="円"
            :spanSetting="spanPriceSide"
          >
          </number-view>
        </el-col>
      </el-row>
      <el-row class="top-level-area">
        <el-col :span="8">
          <el-button type="primary"
                      icon="el-icon-notebook-1"
                      style="display: block; width: 90%;"
                      @click="registItem(false)">保存する</el-button>
        </el-col>
        <el-col :span="8">
          <el-button
            id="button-save-item-move-list"
            type="success"
            icon="el-icon-copy-document"
            style="display: block; width: 90%;"
            @click="registItem(true)"
          >
            保存して一覧に戻る
          </el-button>
        </el-col>
        <el-col :span="8">
          <el-button type="info" icon="el-icon-close" style="display: block; width: 90%;"
                      @click="backToList()">編集キャンセル</el-button>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
// @ is an alias to /src
import Selector from '@/components/Selector.vue'
import ExhibitPriceLabel from '@/components/ExhibitPrice.vue'
import InputText from '@/components/InputText.vue'
import InputTextBox from '@/components/InputTextBox.vue'
import InputNumber from '@/components/InputNumber.vue'
import NumberView from '@/components/NumberView.vue'
import ColorSizeButton from '@/components/ColorSizeButton.vue'
import ColorSizeDialog from '@/components/ColorSizeDialog.vue'
import AreaSelector from '@/components/AreaSelector.vue'
import CategorySelector from '@/components/CategorySelector.vue'
import BrandSelector from '@/components/BrandSelector.vue'
import RequiredTag from '@/components/RequiredTag.vue'
import ShopNote from '@/components/ShopNote.vue'
import StyleNumber from '@/components/StyleNumber.vue'
import api from '@/http/api.js'
import ImageFiles from '@/components/ImageFiles.vue'
import TagsArea from '@/components/TagsArea.vue'

export default {
  name: 'Item',
  components: {
    selector: Selector,
    exhibitPriceLabel: ExhibitPriceLabel,
    inputText: InputText,
    inputTextBox: InputTextBox,
    inputNumber: InputNumber,
    numberView: NumberView,
    colorSizeButton: ColorSizeButton,
    colorSizeDialog: ColorSizeDialog,
    areaSelector: AreaSelector,
    categorySelector: CategorySelector,
    brandSelector: BrandSelector,
    requiredTag: RequiredTag,
    shopNote: ShopNote,
    styleNumber: StyleNumber,
    imageFiles: ImageFiles,
    TagsArea: TagsArea
  },
  data: function () {
    return {
      lenItemName: 60,
      lenItemComment: 3000,
      lenExibitNote: 1000,
      lenColorSizeSup: 1000,
      lenShopName: 30,
      spanLeftSide: 13,
      spanRightSide: 11,
      spanTitleSide: 9,
      spanSettingSide: 14,
      spanPriceSide: 6,
      spanSuffix: 1,
      brandSelection: [],
      seasonSelection: {},
      themeSelection: [],
      deliverySelection: [],
      currencyTypes: [
        { value: 'yen', label: '円' },
        { value: 'dollar', label: 'ドル' },
        { value: 'euro', label: 'ユーロ' },
        { value: 'pound', label: 'ポンド' }
      ],
      tax: 0.1,
      rate: {
        yen: 1,
        dollar: 100,
        euro: 120,
        pound: 140
      },
      charge: 0,
      csDialogVisible: false,
      sizeReferences: [],
      sizeDetails: [],
      tagGroups: [],
      item: this.createNewItem()
    }
  },
  computed: {
    totalStockCost: function () {
      return this.item.stockPrice * this.rate[this.item.currency] + this.item.domesticPostage + this.item.foreignPostage + this.item.dutyCost
    },
    chargeValue: function () {
      return this.charge / 100
    },
    profitRateValue: function () {
      return this.item.profitRate / 100
    },
    profit: function () {
      return Math.floor(this.totalStockCost * (1 + this.chargeValue + this.tax + (this.profitRateValue / (1 - this.profitRateValue))) * this.profitRateValue)
    },
    computedPrice: function () {
      return Math.round(this.totalStockCost * (1 + this.chargeValue + this.tax) + this.profit)
    },
    actualProfitRate: function () {
      return this.profit / this.item.exhibitPrice
    },
    actualProfit: function () {
      return this.item.exhibitPrice * this.actualProfitRate
    }
  },
  mounted: async function () {
    console.log('item_id: ' + this.$route.params.id)
    this.seasonSelection = await api.season.getSeasons()
    this.themeSelection = await api.theme.getThemes()
    this.deliverySelection = await api.delivery.getDeliveryMethods()
    if (this.$route.params != null && this.$route.params.id != null) {
      this.item = await api.item.getItem(this.$route.params.id)
      if (this.item.shopNotes.length === 0) {
        this.item.shopNotes = [{ seqNo: 1, label: '', url: '', description: '' }]
      }
      if (this.item.styleNumbers.length === 0) {
        this.item.styleNumbers = [{ seqNo: 1, number: '', memo: '' }]
      }
      await this.updateBrandSelection()
      await this.updateSizeReferences()
      await this.updateSizeDetails()
      this.tagGroups = await api.tag.getTagGroups(this.item.category3rd)
    } else {
      this.item = this.createNewItem()
    }
    this.getUserConf()
    this.pageLoading = false
  },
  watch: {
    $route: function (to, from) {
      if (to.path === '/newitem') {
        this.item = this.createNewItem()
      }
    }
  },
  methods: {
    createNewItem: function () {
      return {
        id: 0,
        name: '',
        comment: '',
        exhibitNote: '',
        brand: 0,
        theme: 0,
        season: 0,
        deliveryMethod: '',
        purchasePlace: '',
        deliveryPlace: '',
        exhibitPrice: 0,
        purchaseLimit: 14,
        category1st: 0,
        category2nd: 0,
        category3rd: 0,
        colorSizeSup: '',
        sizeUnit: 1,
        variation: '0',
        imageFiles: [],
        colorSelects: [],
        sizeSelects: [{ name: 'f', reference: '', details: [] }],
        status: '0',
        errMsg: '',
        stockPrice: 0,
        currency: 'yen',
        domesticPostage: 0,
        foreignPostage: 0,
        dutyCost: 0,
        profitRate: 0,
        shopNotes: [{ seqNo: 1, label: '', url: '', description: '' }],
        capacityAmount: '',
        shopName: '',
        styleNumbers: [{ seqNo: 1, number: '', memo: '' }],
        tags: [],
        brandname: ''
      }
    },
    getUserConf: function () {
      api.userconfig.getConfiguration('DOLLAR').then(value => {
        this.rate.dollar = Number(value)
      })
      api.userconfig.getConfiguration('EURO').then(value => {
        this.rate.euro = Number(value)
      })
      api.userconfig.getConfiguration('POUND').then(value => {
        this.rate.pound = Number(value)
      })
      api.userconfig.getConfiguration('CHARGE').then(value => {
        this.charge = Number(value)
      })
    },
    updateBrandSelection: async function () {
      this.brandSelection = await api.brand.getBrands()
    },
    changeCategory1st: function (id) {
      this.item.category1st = id
      this.item.category2nd = 0
      this.item.category3rd = 0
      this.clearDependOnCategory()
    },
    changeCategory2nd: function (id) {
      this.item.category2nd = id
      this.item.category3rd = 0
      this.clearDependOnCategory()
    },
    changeCategory3rd: async function (id) {
      this.item.category3rd = id
      this.clearDependOnCategory()
      await this.updateSizeReferences()
      await this.updateSizeDetails()
      for (const detail of this.sizeDetails) {
        this.item.sizeSelects[0].details.push({ id: detail.id, value: '' })
      }
      this.tagGroups = await api.tag.getTagGroups(this.item.category3rd)
    },
    updateSizeReferences: async function () {
      this.sizeReferences = await api.size.getSizeReferences(
        this.item.category1st,
        this.item.category2nd,
        this.item.category3rd
      )
    },
    updateSizeDetails: async function () {
      this.sizeDetails = await api.size.getSizeDetails(
        this.item.category1st,
        this.item.category2nd,
        this.item.category3rd
      )
    },
    clearDependOnCategory: function () {
      this.item.sizeUnit = 1
      this.item.variation = '0'
      this.item.sizeSelects = [{ name: 'f', reference: '', details: [] }]
      this.item.tags = []
    },
    registItem: function (transToList) {
      var validResult = this.validateItem()
      this.item.errMsg = validResult.msg
      if (!(validResult.continuous)) {
        this.notifyFailSaveData(validResult.msg)
        return
      }
      if (this.item.id === 0) {
        api.item.insertItem(this.item).then(data => {
          if (data.result === 'OK') {
            this.notifySuccessSaveData()
            this.item.id = data.id
            if (transToList) {
              this.backToList()
            }
          } else {
            this.notifyFailSaveData('通信エラーが発生しました。')
          }
        })
      } else {
        // 既存データ更新時
        api.item.updateItem(this.item).then(data => {
          if (data.result === 'OK') {
            this.notifySuccessSaveData()
            this.item.id = data.id
            if (transToList) {
              this.backToList()
            }
          } else {
            this.notifyFailSaveData('通信エラーが発生しました。')
          }
        })
      }
    },
    backToList: function () {
      this.$router.push('/itemlist')
    },
    validateItem: function () {
      var result = {
        continuous: true,
        msg: ''
      }
      var errMsg = ''
      if (this.getTextLength(this.item.name) > this.lenItemName) {
        errMsg = errMsg + '商品名の文字数が規定文字数を超過しています。\n'
        result.continuous = false
      }
      if (this.getTextLength(this.item.comment) > this.lenItemComment) {
        errMsg = errMsg + '商品コメントの文字数が規定文字数を超過しています。\n'
        result.continuous = false
      }
      if (this.getTextLength(this.item.exhibitNote) > this.lenExibitNote) {
        errMsg = errMsg + '出品メモの文字数が規定文字数を超過しています。\n'
        result.continuous = false
      }
      if (this.getTextLength(this.item.colorSizeSup) > this.lenColorSizeSup) {
        errMsg = errMsg + '色・サイズ補足情報の文字数が規定文字数を超過しています。\n'
        result.continuous = false
      }
      if (this.getTextLength(this.item.shopName) > this.lenShopName) {
        errMsg = errMsg + '買付先ショップ名の文字数が規定文字数を超過しています。\n'
        result.continuous = false
      }
      if (this.item.name.length <= 0) {
        errMsg = errMsg + '商品名の指定がありません。\n'
        result.continuous = false
      }
      if (result.continuous) {
        if (this.includeHalfKana(this.item.name)) {
          errMsg = errMsg + '商品名に半角カナが含まれています。\n'
        }
        if (this.includeHalfKana(this.item.comment)) {
          errMsg = errMsg + 'コメントに半角カナが含まれています。\n'
        }
        if (this.includeHalfKana(this.item.exhibitNote)) {
          errMsg = errMsg + '出品メモに半角カナが含まれています。\n'
        }
        if (this.includeHalfKana(this.item.colorSizeSup)) {
          errMsg = errMsg + '色・サイズ補足情報に半角カナが含まれています。\n'
        }
        for (var i = 0; i < this.item.colorSelects.length; i++) {
          if (this.includeHalfKana(this.item.colorSelects[i].name)) {
            errMsg = errMsg + '色名(' + (i + 1) + ')に半角カナが含まれています。\n'
          }
        }
        if (this.item.brand.length <= 0) {
          errMsg = errMsg + 'ブランドが指定されていません。\n'
        }
        if (this.item.category1st <= 0 ||
            this.item.category2nd <= 0 ||
            this.item.category3rd <= 0) {
          errMsg = errMsg + 'カテゴリが指定されていません。\n'
        }
        if (this.item.comment.length <= 0) {
          errMsg = errMsg + '商品コメントの記述がありません。\n'
        }
        if (this.item.deliveryMethod.length <= 0) {
          errMsg = errMsg + '発送方法が指定されていません。\n'
        }
        if (this.item.purchasePlace.length <= 0) {
          errMsg = errMsg + '買付地が指定されていません。\n'
        }
        if (this.item.deliveryPlace.length <= 0) {
          errMsg = errMsg + '発送地が指定されていません。\n'
        }
        if (this.item.capacityAmount !== '') {
          if (this.item.capacityAmount.replace(/[0-9]+/, '') !== '') {
            errMsg = errMsg + '買付できる合計数量に数字以外が含まれています。\n'
          } else if (this.item.capacityAmount.length > 3) {
            errMsg = errMsg + '買付できる合計数量は999以下を指定してください。\n'
          }
        }
        // 禁止文字削除
        this.item.name = this.removeInvisibleCharactors(this.item.name)
        this.item.comment = this.removeInvisibleCharactors(this.item.comment)
        this.item.exhibitNote = this.removeInvisibleCharactors(this.item.exhibitNote)
        this.item.colorSizeSup = this.removeInvisibleCharactors(this.item.colorSizeSup)
        this.item.shopName = this.removeInvisibleCharactors(this.item.shopName)
      }
      result.msg = errMsg
      return result
    },
    getTextLength: function (str) {
      var result = 0
      for (var i = 0; i < str.length; i++) {
        var chr = str.charCodeAt(i)
        if ((chr >= 0x00 && chr < 0x81) ||
            (chr === 0xf8f0) ||
            (chr >= 0xff61 && chr < 0xffa0) ||
            (chr >= 0xf8f1 && chr < 0xf8f4)) {
          // 半角文字の場合は1を加算
          result += 1
        } else {
          // それ以外の文字の場合は2を加算
          result += 2
        }
      }
      // 結果を返す
      return result
    },
    includeHalfKana: function (str) {
      for (var i = 0; i < str.length; i++) {
        var chr = str.charCodeAt(i)
        if (chr >= 0xff61 && chr < 0xffa0) {
          return true
        }
      }
      return false
    },
    removeInvisibleCharactors: function (str) {
      return str.replaceAll(/[\u200B-\u200F\u2028-\u202E\u2061-\u2063]/g, '')
    },
    notifySuccessSaveData: function () {
      this.$notify({
        title: 'データ保存成功',
        message: 'データ保存が完了しました。',
        type: 'success',
        duration: 1500
      })
    },
    notifyFailSaveData: function (cause) {
      this.$notify({
        title: 'データ保存失敗',
        message: 'データ保存ができませんでした。' + (cause === '' ? '' : '\n' + cause),
        type: 'error',
        duration: 1500
      })
    }
  }
}
</script>

<style scoped>
.el-container {
  margin: 0 auto 0;
  width: 980px;
}
.el-row {
  margin-bottom: 5px;
}
.el-row.top-level-area {
  margin-bottom: 20px;
}
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 5px;
  margin-right: 10px;
}
div.input-title-block {
  text-align: left;
  margin-right: 10px;
  margin-bottom: 2px;
}
.required input {
  background: rgb(255, 192, 192);
}
.required textarea {
  background: rgb(255, 192, 192);
}
.optional input {
  background: rgb(192, 255, 192);
}
.optional textarea {
  background: rgb(192, 255, 192);
}
</style>
